import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getProductLines } from '../data/productsLoader';
import { RangeSection } from '../components/products/RangeSection';
import { ServiceHighlights } from '../components/products/ServiceHighlights';
import { ProductsCTA } from '../components/products/ProductsCTA';
import { PageHero } from '../components/shared/PageHero';
import { useSEO } from '../hooks/useSEO';

export default function Products() {
  useSEO({
    title: 'Gama de Patinetes Eléctricos',
    description: 'Explora nuestras series ZWolf, ZCougar, ZRino, ZLion, ZFox y ZToy. Encuentra el patinete perfecto para ti.',
    keywords: 'comprar patinete eléctrico, zfox, zlion, zrino, zwolf, zcougar, ztoy'
  });

  const { hash } = useLocation();

  // Scroll to section if hash is present
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  // Get product lines from productsLoader (already in correct order)
  const productLines = getProductLines();

  return (
    <div className="bg-white">
      {/* Page Hero - 参考 Blog 页面 */}
      <PageHero
        title="Gama de Patinetes Eléctricos"
        subtitle="Desde la potencia off-road hasta la agilidad urbana. Diseñamos el futuro de tu movilidad con la tecnología más avanzada."
      />

      {/* Ranges List */}
      <div className="flex flex-col">
        {productLines.map((line, index) => (
          <RangeSection
            key={line.id}
            productLine={line}
            isAlternate={index % 2 !== 0}
          />
        ))}
      </div>

      {/* Service Highlights - 服务卖点 */}
      <ServiceHighlights />

      {/* CTA Section - 需要帮助模块 */}
      <ProductsCTA />
    </div>
  );
}
